module.exports = ['$scope', ($scope) ->
  @assetHoldings = 'assetClasses'
  @mobileColumn = 'weighting'

  doNotShowPortfolioName = (portfolioModelName) =>
    # guards against timing errors
    return true if portfolioModelName is null or portfolioModelName is undefined
    return ['check trello', 'internal'].includes(portfolioModelName.toLowerCase().trim())

  @validPortfolioName = =>
    return false if @account is undefined or doNotShowPortfolioName(@account.portfolioModelName) is true
    return true

  @pieChartData = =>
    return if @account is undefined
    if @assetHoldings == 'holdings' then @holdings else @assetClasses

  $scope.$watch 'ctrl.account', (account) =>
    return if account is undefined
    @hasPositions = account.positions.length > 0
    @holdings = account.positions
    @accountHoldingsUrl = "accounts/#{account.id}/holdings"

  $scope.$watch 'ctrl.assetClasses', (assetClasses) =>
    return if assetClasses is undefined
    @maxAssetClassAllocation = _.maxBy(assetClasses, 'allocation').allocation

  @
]
